import React, { Component } from 'react';
import storage from 'store';
import * as clevertapCapital from 'clevertap/capital';
import { connect } from 'react-redux';
import styles from './IncompleteProfile.css';

class IncompleteProfile extends Component {
  componentDidMount() {
    storage.set('hasClickApply', false);

    clevertapCapital.incompleteProfile();
  }

  render() {
    const title = 'Please fill in your Business Profile details';
    const description =
      'Sorry but you’re ineligible to apply for a loan at the moment. Please try again after you complete your Business Profile.';
    return (
      <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding`}>
        <div className="full-height-no-data-display">
          <div className={`${styles['not-requirement-container']} box-spinner`}>
            <div className={`${styles['content-not-requirement']}`}>
              <img src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/capital/not_meet_the_requirement.svg" />
              <div>
                <h3 className={styles.title}>{title}</h3>
              </div>
              <div
                className={`${styles.description} ${
                  styles['description-box']
                } col-md-9 col-lg-9`}
              >
                <p>{description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

IncompleteProfile.propTypes = {};

function mapStateToProps(state) {
  const { borrowerProfile } = state.capital;
  return {
    borrowerProfile,
  };
}

export default connect(mapStateToProps)(IncompleteProfile);
